import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { groqVendorProjection } from "../sanity/vendor.projection"

export const queryVendor = {
  async vendor(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), cdn = true, id } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.VENDORS,
      operation: Operations.READ,
    })

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    let vendor
    vendor = await client.fetch(
      groq`*[_type=="vendor" && id==$id ${draftsFilter}][0]{
        ${groqVendorProjection()}
      }`,
      { id: parseInt(id) },
    )

    vendor = vendor || null

    return vendor
  },
}
